export default __webpack_public_path__ + "static/media/Biryani-by-Kilo.1b04d4c8.jpg";